import template from './adpSimpleTable.html';
import controller from './adpSimpleTable.controller';
import './adpSimpleTable.less';

let adpSimpleTableComponent = {
  restrict: 'E',
  bindings: {
  	data: '<',
  	hoverIcon: '@',
  },
  template,
  controller
};

export default adpSimpleTableComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSimpleTable/adpSimpleTable.component.js